export function isVotingStageSponsorship(item) {
    return item?.type === "VotingStageSponsorship";
}
export function isVotingStageSponsorshipBase(item) {
    return item?.type === "VotingStageSponsorshipBase";
}
//# sourceMappingURL=voting-stage-sponsorship.js.map